/* eslint-disable react-func/max-lines-per-function */
import { PACKAGE_BOUGHT, PACKAGE_DELIVERED, PACKAGE_IN_TRANSIT, PACKAGE_ON_DELIVERY, PACKAGE_PROCESSED, PACKAGE_RECEIVED } from '../constants/packageStatus'
import {
  TRACKING_STEPS,
  INACTIVE_ICONS_URL,
  TRACKING_INACTIVE_1,
  TRACKING_INACTIVE_2,
  TRACKING_INACTIVE_3,
  TRACKING_INACTIVE_4,
  TRACKING_INACTIVE_5
} from '../constants/urls'

export const baseStates = () => [
  {
    value: PACKAGE_BOUGHT,
    name: 'Comprado',
    activeIcon: `${TRACKING_STEPS.bought}`,
    inactiveIcon: `${INACTIVE_ICONS_URL}/${TRACKING_INACTIVE_1}`,
    textSales: 'Exitosa'
  },
  {
    value: PACKAGE_PROCESSED,
    name: 'Procesado',
    activeIcon: `${TRACKING_STEPS.processed}`,
    inactiveIcon: `${INACTIVE_ICONS_URL}/${TRACKING_INACTIVE_2}`,
    textSales: 'Procesada'
  },
  {
    value: PACKAGE_IN_TRANSIT,
    name: 'Enviado',
    activeIcon: `${TRACKING_STEPS['in-transit']}`,
    inactiveIcon: `${INACTIVE_ICONS_URL}/${TRACKING_INACTIVE_3}`,
    textSales: 'Enviada'
  },
  {
    value: PACKAGE_ON_DELIVERY,
    name: 'Despachado',
    activeIcon: `${TRACKING_STEPS['on-delivery']}`,
    inactiveIcon: `${INACTIVE_ICONS_URL}/${TRACKING_INACTIVE_3}`,
    textSales: 'Enviada'
  }
]

export const homeDeliveryStates = () => [
  ...baseStates(),
  {
    value: PACKAGE_DELIVERED,
    name: 'Entregado',
    activeIcon: `${TRACKING_STEPS.delivered}`,
    inactiveIcon: `${INACTIVE_ICONS_URL}/${TRACKING_INACTIVE_5}`,
    textSales: 'Entregada'
  }
]

export const clickAndCollectStates = () => [
  ...baseStates(),
  {
    value: PACKAGE_RECEIVED,
    name: 'Recepcionado',
    activeIcon: `${TRACKING_STEPS.received}`,
    inactiveIcon: `${INACTIVE_ICONS_URL}/${TRACKING_INACTIVE_4}`,
    textSales: 'Recepcionada'
  },
  {
    value: PACKAGE_DELIVERED,
    name: 'Entregado',
    activeIcon: `${TRACKING_STEPS.delivered}`,
    inactiveIcon: `${INACTIVE_ICONS_URL}/${TRACKING_INACTIVE_5}`,
    textSales: 'Entregada'
  }
]
